import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { SecureHttp } from '@app/security/secure-http';
import { Observable } from 'rxjs';
import {
  SmartActionPostPayload,
  SmartActionPutPayload,
} from '@app/smart-actions/types/smart-actions';

@Injectable()
export class SmartActionsService {
  constructor(private http: SecureHttp) {}

  postSmartAction(
    clientId: string,
    payload: SmartActionPostPayload,
  ): Observable<any> {
    const url = `${environment.portalURLBase}/client/${clientId}/smart-actions`;
    return this.http.post(url, payload);
  }

  getSmartActionsList(clientId: string): Observable<any[]> {
    const url = `${environment.portalURLBase}/client/${clientId}/smart-actions`;
    return this.http.get(url);
  }

  putSmartAction(
    clientId: string,
    smartActionId: string,
    payload: SmartActionPutPayload,
  ): Observable<any> {
    const url = `${environment.portalURLBase}/client/${clientId}/smart-actions/${smartActionId}`;
    return this.http.put(url, payload);
  }

  deleteSmartAction(
    clientId: string,
    smartActionId: string,
  ): Observable<any[]> {
    const url = `${environment.portalURLBase}/client/${clientId}/smart-actions/${smartActionId}`;
    return this.http.delete(url);
  }

  getForm(clientId: string, formId: string): Observable<any> {
    const url = `${environment.powerUpApiURLBase}/${clientId}/form/${formId}`;
    return this.http.get(url);
  }
}
